<template>
    <div>
        <eqt-table
            :icon="icon"
            :color="color"
            :header-color="headerColor"
            :hide-search="hideSearch"
            :hide-pagination="hidePagination"
            :hide-show-btn="hideShowBtn"
            :hide-edit-btn="hideEditBtn"
            @refresh="refresh"
            :total="total"
            :loading="loading"
            :title="computedTitle"
            :items="items"
            hide-actions
            :headers="computedHeaders"
            :expandable="true">
                <template slot="filters">
                    <v-flex lg3>
                        <v-autocomplete
                            :search-input.sync="qUser"
                            v-model="data.users"
                            :items="users"
                            :loading="usersLoading"
                            name="users"
                            color="indigo"
                            hide-no-data
                            hide-selected
                            clearable
                            multiple
                            item-text="profile.name"
                            item-value="id"
                            :label="$t('Pages.Users.title_singular')"
                            :placeholder="$t('Common.type_to_search')"
                            prepend-icon="mdi-account-group"
                        ></v-autocomplete>
                    </v-flex>
                    <v-flex lg3>
                        <v-select
                            v-model="data.userCheckoutFormStatuses"
                            :items="Object.values(userCheckoutFormStatuses)"
                            name="userCheckoutFormStatuses"
                            color="indigo"
                            hide-no-data
                            hide-selected
                            clearable
                            multiple
                            :label="$t('Pages.UserCheckoutFormStatuses.title_singular')"
                            prepend-icon="mdi-playlist-check"
                        ></v-select>
                    </v-flex>
                    <v-flex lg1 offset-lg2>
                        <v-tooltip top>
                            <v-btn
                                slot="activator"
                                absolute
                                right
                                small
                                fab
                                dark
                                color="indigo dark1"
                                @click="refresh(null, 1)">
                                <v-icon dark>mdi-download</v-icon>
                            </v-btn>
                            <span>{{$t('Core.Fields.download')}}</span>
                        </v-tooltip>
                    </v-flex>
                    <v-flex lg3>
                        <v-dialog
                                ref="dialogStartFrom"
                                v-model="modalStartFrom"
                                :return-value.sync="data.startFrom"
                                persistent
                                lazy
                                full-width
                                width="290px"
                        >
                            <v-text-field
                                    clearable
                                    slot="activator"
                                    v-model="computedStartFrom"
                                    :label="$t('Pages.UserCheckoutForms.model.start_from')"
                                    prepend-icon="event"
                                    readonly
                                    color="indigo"
                                    :error-messages="errors.first('startFrom')"
                                    name="startFrom"
                            ></v-text-field>
                            <v-date-picker locale="sr-Latn-RS" first-day-of-week="1" color="indigo" v-model="data.startFrom" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat @click="modalStartFrom = false">{{$t('Core.Fields.cancel')}}</v-btn>
                                <v-btn flat color="indigo" @click="$refs.dialogStartFrom.save(data.startFrom)">{{$t('Core.Fields.ok')}}</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                    <v-flex lg3>
                        <v-dialog
                                ref="dialogStartTo"
                                v-model="modalStartTo"
                                :return-value.sync="data.startTo"
                                persistent
                                lazy
                                full-width
                                width="290px"
                        >
                            <v-text-field
                                    clearable
                                    slot="activator"
                                    v-model="computedStartTo"
                                    :label="$t('Pages.UserCheckoutForms.model.start_to')"
                                    prepend-icon="event"
                                    readonly
                                    color="indigo"
                                    :error-messages="errors.first('startTo')"
                                    name="startTo"
                            ></v-text-field>
                            <v-date-picker locale="sr-Latn-RS" first-day-of-week="1" color="indigo" v-model="data.startTo" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat @click="modalStartTo = false">{{$t('Core.Fields.cancel')}}</v-btn>
                                <v-btn flat color="indigo" @click="$refs.dialogStartTo.save(data.startTo)">{{$t('Core.Fields.ok')}}</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                    <v-flex lg3>
                        <v-dialog
                                ref="dialogEndFrom"
                                v-model="modalEndFrom"
                                :return-value.sync="data.endFrom"
                                persistent
                                lazy
                                full-width
                                width="290px"
                        >
                            <v-text-field
                                    clearable
                                    slot="activator"
                                    v-model="computedEndFrom"
                                    :label="$t('Pages.UserCheckoutForms.model.end_from')"
                                    prepend-icon="event"
                                    readonly
                                    color="indigo"
                                    :error-messages="errors.first('endFrom')"
                                    name="endFrom"
                            ></v-text-field>
                            <v-date-picker  locale="sr-Latn-RS" :min="data.start" first-day-of-week="1" color="indigo" v-model="data.endFrom" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat @click="modalEndFrom = false">{{$t('Core.Fields.cancel')}}</v-btn>
                                <v-btn flat color="indigo" @click="$refs.dialogEndFrom.save(data.endFrom)">{{$t('Core.Fields.ok')}}</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                    <v-flex lg3>
                        <v-dialog
                                ref="dialogEndTo"
                                v-model="modalEndTo"
                                :return-value.sync="data.endTo"
                                persistent
                                lazy
                                full-width
                                width="290px"
                        >
                            <v-text-field
                                    clearable
                                    slot="activator"
                                    v-model="computedEndTo"
                                    :label="$t('Pages.UserCheckoutForms.model.end_to')"
                                    prepend-icon="event"
                                    readonly
                                    color="indigo"
                                    :error-messages="errors.first('endTo')"
                                    name="endTo"
                            ></v-text-field>
                            <v-date-picker  locale="sr-Latn-RS" :min="data.start" first-day-of-week="1" color="indigo" v-model="data.endTo" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat @click="modalEndTo = false">{{$t('Core.Fields.cancel')}}</v-btn>
                                <v-btn flat color="indigo" @click="$refs.dialogEndTo.save(data.endTo)">{{$t('Core.Fields.ok')}}</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                </template>
                <template slot="items" slot-scope="{ props }">
                    <td>{{ props.item.profile.name }}</td>
                    <td class="text-xs-center">{{ props.item.email }}</td>
                    <td class="text-xs-center">{{ props.item.jmbg ? props.item.jmbg : $t('Common.not_assigned') }}</td>
                </template>
                <template slot="expand" slot-scope="{ props }">
                    <v-list>
                        <template
                            v-for="activeUserCheckoutForm in props.item.userCheckoutForms">
                                <span class="body-1">
                                    {{ $t('Pages.UserCheckoutForms.title_singular') +
                                        ': ' + getLocaleDateFormat(activeUserCheckoutForm.start) +
                                        ' - ' + (activeUserCheckoutForm.expiration ?
                                            getLocaleDateFormat(activeUserCheckoutForm.expiration) :
                                            $t('Common.no_expiration')) }}
                                </span>
                                <ul class="mb-2">
                                    <li v-for="info in activeUserCheckoutForm.info">{{ info.product + " - " + info.quantity }}</li>
                                </ul>
                        </template>
                    </v-list>
                </template>
        </eqt-table>
    </div>
</template>

<script>
    import EqtTable from '../../../components/core/Table'
    import i18n from '@/i18n'
    import _ from "lodash";
    export default {
        name: "reports-table",
        components: {EqtTable},
        props: {
            items: {
              type: Array,
              required: true
            },
            total: {
                type: Number,
                default: 0,
            },
            loading: {
                type: Boolean,
                default: false
            },
            hideActions: {
                type: Boolean,
                default: false
            },
            icon: {
                type: String,
                default: ''
            },
            color: {
                type: String,
                default: 'tertiary'
            },
            headerColor: {
                type: String,
                default: 'text-primary text--darken-3'
            },
            title: {
                type: String,
                default: null,
            },
            hidePagination: {
                type: Boolean,
                default: false
            },
            hideSearch: {
                type: Boolean,
                default: false
            },
            hideShowBtn: {
                type: Boolean,
                default: false
            },
            hideEditBtn: {
                type: Boolean,
                default: false
            },
            sortable: {
                type: Boolean,
                default: true
            },
            appendHeaders: {
                type: Array,
                default: () => []
            },
        },
        data() {
            return {
                headers: [
                    {
                        sortable: false,
                        text: i18n.t('Pages.Users.model.name'),
                        value: 'profile.name'
                    },
                    {
                        sortable: false,
                        text: i18n.t('Pages.Users.model.email'),
                        value: 'email',
                        align: 'center'
                    },
                    {
                        sortable: false,
                        text: i18n.t('Pages.Users.model.jmbg'),
                        value: 'jmbg',
                        align: 'center'
                    },
                    {
                        sortable: this.sortable && false,
                        text: '',
                    },
                ],
                data: {},
                search: { product: null, warehouse: null },
                qUser: null,
                users: [],
                usersLoading: false,
                modalStartFrom: false,
                modalStartTo: false,
                modalEndFrom: false,
                modalEndTo: false,
            };
        },
        computed:{
            computedHeaders(){
                return this.headers.concat(this.appendHeaders);
            },
            computedTitle(){
                return this.title ? this.title : this.$t('Pages.Reports.warehouse_states_title');
            },
            computedStartFrom: {
                get: function () {
                    return this.getLocaleDateFormat(this.data.startFrom);
                },
                set: function(val){
                    this.data.startFrom = val;
                }
            },
            computedStartTo: {
                get: function () {
                    return this.getLocaleDateFormat(this.data.startTo);
                },
                set: function(val){
                    this.data.startTo = val;
                }
            },
            computedEndFrom: {
                get: function () {
                    return this.getLocaleDateFormat(this.data.endFrom);
                },
                set: function(val){
                    this.data.endFrom = val;
                }
            },
            computedEndTo: {
                get: function () {
                    return this.getLocaleDateFormat(this.data.endTo);
                },
                set: function(val){
                    this.data.endTo = val;
                }
            },
        },
        methods: {
            refresh(data, shouldExport = 0){
                if(data) {
                    this.data = data;
                }
                else{
                    data = this.data;
                }

                data.export = shouldExport;

                this.$emit('refresh', data);
            },
        },
        watch: {
            qUser: _.debounce(function(val){
                if(!val) return;
                // Items have already been loaded
                if (val.length < 2) return;

                // Items have already been requested
                if (this.usersLoading) return;

                this.usersLoading = true;
                this.repositories.user.all(val).then((response) => {
                    this.users = response.data.data;
                }).finally(() => {
                    this.usersLoading = false;
                });
            }, 500),
            'data.users': function () {
                this.refresh();
            },
            'data.userCheckoutFormStatuses': function () {
                this.refresh();
            },
            'data.startFrom': function () {
                this.refresh();
            },
            'data.startTo': function () {
                this.refresh();
            },
            'data.endFrom': function () {
                this.refresh();
            },
            'data.endTo': function () {
                this.refresh();
            },
        }
    }
</script>

<style scoped>

</style>
